import React from 'react'
import { Card } from 'primereact/card'

interface StatsCardProps {
  title: string
  value: string | number
  icon: string
  trend?: {
    value: string | number
    isPositive: boolean
  }
  color?: 'blue' | 'green' | 'purple' | 'orange' | 'red'
  clickable?: boolean
  onClick?: () => void
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  icon,
  trend,
  color = 'blue',
  clickable = false,
  onClick
}) => {
  const colorClasses = {
    blue: 'from-blue-500 to-blue-600',
    green: 'from-green-500 to-green-600',
    purple: 'from-purple-500 to-purple-600',
    orange: 'from-orange-500 to-orange-600',
    red: 'from-red-500 to-red-600'
  }

  const cardContent = (
    <div className="flex items-start justify-between">
      <div className="flex-1">
        <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
        <p className="text-3xl font-bold text-gray-900 mb-2">{value}</p>
        {trend && (
          <div className="flex items-center">
            <i className={`pi ${trend.isPositive ? 'pi-arrow-up text-green-500' : 'pi-arrow-down text-red-500'} text-sm mr-1`}></i>
            <span className={`text-sm ${trend.isPositive ? 'text-green-600' : 'text-red-600'}`}>
              {trend.value}
            </span>
          </div>
        )}
      </div>
      <div className={`p-3 rounded-lg bg-gradient-to-r ${colorClasses[color]}`}>
        <i className={`${icon} text-white text-xl`}></i>
      </div>
    </div>
  )

  return (
    <Card
      className={`h-full ${clickable ? 'cursor-pointer hover:shadow-lg transition-shadow' : ''}`}
      onClick={clickable ? onClick : undefined}
    >
      {cardContent}
    </Card>
  )
}

export default StatsCard